import { type AccountStatus, type TicketStatus } from '@lsc/domain';

/** A dot and a word. Columns of these read as text with a color cue, not a row of badges. */
const STATUS: Record<AccountStatus, { text: string; dot: string }> = {
  active: { text: 'Active', dot: 'bg-live' },
  trailing: { text: 'Trailing', dot: 'bg-attention' },
  pending: { text: 'Pending', dot: 'bg-info' },
  cancellation_requested: { text: 'Cancel requested', dot: 'bg-alert' },
  collections: { text: 'Collections', dot: 'bg-alert' },
  closed: { text: 'Closed', dot: 'bg-ink-3' },
  unknown: { text: 'Unknown', dot: 'bg-ink-3' },
};

export function StatusWord({ status, className = '' }: { status: AccountStatus; className?: string }) {
  const s = STATUS[status];
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap ${className}`}>
      <span aria-hidden className={`inline-block size-1.5 rounded-full ${s.dot}`} />
      {s.text}
    </span>
  );
}

export function statusText(status: AccountStatus): string {
  return STATUS[status].text;
}

const TICKET_STATUS: Record<TicketStatus, { text: string; dot: string }> = {
  open: { text: 'Open', dot: 'bg-info' },
  in_progress: { text: 'In progress', dot: 'bg-live' },
  waiting_on_merchant: { text: 'Waiting', dot: 'bg-attention' },
  stuck: { text: 'Stuck', dot: 'bg-alert' },
  resolved: { text: 'Resolved', dot: 'bg-ink-3' },
  // One done state in words (2026-10-27): a closed ticket reads Resolved, as the button says.
  closed: { text: 'Resolved', dot: 'bg-ink-3' },
};

export function TicketStatusWord({ status, className = '' }: { status: TicketStatus; className?: string }) {
  const s = TICKET_STATUS[status];
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap ${className}`}>
      <span aria-hidden className={`inline-block size-1.5 rounded-full ${s.dot}`} />
      {s.text}
    </span>
  );
}

export function ticketStatusText(status: TicketStatus): string {
  return TICKET_STATUS[status].text;
}
